import { getJSON } from 'common/services/api'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import type { AllocationFiltersValue } from '../RotaBuilder/screens/AllocationWindow/components/AllocationFilters'
import type { AllocationMember } from '../types'
import {
  ALLOCATION_LIST_QUERY_KEY,
  ALLOCATION_LIST_URL
} from './queryConstants'

type UseAllocationList = {
  allocationList: AllocationMember[]
  numberOfSupply: number
  selectedUsers: number
  isListLoading: boolean
  setPage: (page: PageProps) => void
  pagination: Pagination
}

type UseAllocationListProps = {
  id?: string
  allocationListFilters?: AllocationFiltersValue
  skipPagination?: boolean
}

type Pagination = {
  currentPage: number
  totalItems: number
  totalPages?: number
  itemsPerPage: number
}

type PageProps = { index: number; size: number }

export const PAGE_SIZE = 10

const initialPage = { index: 1, size: PAGE_SIZE }

const useAllocationList = ({
  id,
  allocationListFilters,
  skipPagination
}: UseAllocationListProps): UseAllocationList => {
  const [page, setPage] = useState<PageProps>(initialPage)

  const skipListPagination = skipPagination || allocationListFilters?.selected

  const listParams = getQueryParams({
    ...(skipListPagination
      ? { page: 1, limit: 1000 }
      : { page: page.index, limit: page.size }),
    ...allocationListFilters
  })

  const { isLoading: isListLoading, data: allocationListData } = useQuery(
    [
      ALLOCATION_LIST_QUERY_KEY,
      id,
      page.index,
      page.size,
      allocationListFilters
    ] as string[],
    () =>
      getJSON({
        url: `${ALLOCATION_LIST_URL}/${id}?${listParams}`,
        isRota: true
      }),
    { enabled: !!id }
  )

  return {
    allocationList: allocationListData?.teamMembers ?? [],
    numberOfSupply: allocationListData?.numberOfSupply ?? 0,
    selectedUsers: allocationListData?.selected ?? 0,
    isListLoading,
    pagination: allocationListData?.pagination,
    setPage
  }
}

export default useAllocationList
